<template>
  <div class="top">
    <h3 class="top-title">{{ title }}</h3>
  </div>
</template>
<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}

</script>
<style lang="less" scoped>
@import "../../../../stylesheets/base/fn.less";
.top {
  text-align: center;
  background: #333;
  border-top-left-radius: 10/@w;
  border-top-right-radius: 10/@w;

  &-title{
    position: relative;
    font-family: PingFangSC-Semibold;
    font-size: 16/@w;
    color: #ffffff;
    height: 48/@w;
    line-height: 48/@w;
    // box-shadow: 0 2/@w 4/@w 0 rgba(51, 51, 51, 0.5);

    &:before{
      position: absolute;
      content: "";
      left: 0;
      bottom: -8/@w;
      width: 0;
      height: 0;
      border-top: 4/@w solid #0b0b0b;
      border-right: 4/@w solid #0b0b0b;
      border-left: 4/@w solid transparent;
      border-bottom: 4/@w solid transparent;
    }

    &:after{
      position: absolute;
      content: "";
      right: 0;
      bottom: -8/@w;
      width: 0;
      height: 0;
      border-top: 4/@w solid #0b0b0b;
      border-left: 4/@w solid #0b0b0b;
      border-right: 4/@w solid transparent;
      border-bottom: 4/@w solid transparent;
    }
  }
}
</style>
